module.exports = __webpack_public_path__ + "img/2ef0713.png";